import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { CloseButton } from 'secondstep-components'

import { CancelButton, ModalHeaderInput } from '../../component.styles'
import {
  HideButton,
  HideButtonsWrapper,
  HideCheckBox,
  HideMessageWrapper,
  HideWarningSpan,
  ModalWrapperHide,
} from './component.styles'
import {
  HIDE_CANCEL,
  HIDE_CONFIRM,
  HIDE_HEADER,
  HIDE_MESSAGE,
  HIDE_SUBMIT,
  HIDE_WARNING,
} from './constants'

const HideSmallGroup = ({
  courseInstanceName,
  dataTestId,
  handleCancel,
  handleSubmit,
  isClassCardMenu,
}) => {
  const [isDisabled, setIsDisabled] = useState(true)

  const ModalComponent = ModalWrapperHide

  return (
    <ModalComponent dataTestId={dataTestId} isClassCardMenu={isClassCardMenu}>
      <CloseButton dataTestId="button-close" onClick={handleCancel} />
      <ModalHeaderInput dataTestId="modal-hide-header">
        {HIDE_HEADER(courseInstanceName)}
      </ModalHeaderInput>
      <HideWarningSpan>{HIDE_WARNING}</HideWarningSpan>
      <HideMessageWrapper>
        <span>{HIDE_MESSAGE}</span>
      </HideMessageWrapper>
      <HideCheckBox
        dataTestId="hide-input"
        onChange={() => setIsDisabled(!isDisabled)}
        options={[HIDE_CONFIRM]}
        selected={{ [HIDE_CONFIRM]: !isDisabled }}
      />
      <HideButtonsWrapper>
        <CancelButton dataTestId="button-cancel" onClick={handleCancel}>
          {HIDE_CANCEL}
        </CancelButton>
        <HideButton
          dataTestId="button-hide-small-group"
          disabled={isDisabled}
          isDisabled={isDisabled}
          onClick={handleSubmit}
        >
          {HIDE_SUBMIT}
        </HideButton>
      </HideButtonsWrapper>
    </ModalComponent>
  )
}

HideSmallGroup.propTypes = {
  courseInstanceName: PropTypes.string,
  dataTestId: PropTypes.string,
  handleCancel: PropTypes.func,
  handleSubmit: PropTypes.func,
  isClassCardMenu: PropTypes.bool,
}

export default HideSmallGroup
